import { render, staticRenderFns } from "./PracticePage.vue?vue&type=template&id=92e76e26&scoped=true"
import script from "./PracticePage.vue?vue&type=script&lang=js"
export * from "./PracticePage.vue?vue&type=script&lang=js"
import style0 from "./PracticePage.vue?vue&type=style&index=0&id=92e76e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e76e26",
  null
  
)

export default component.exports